/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyLock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#6B7180"
      fillRule="evenodd"
      d="M74.622 28.332c8.236-.979 14.058 3.875 14.058 11.963v13.402c0 4.591-2.383 9.725-7.093 9.725h-21.74c-4.71 0-8.53-3.722-8.53-8.313v-13.86c0-6.812 2.727-10.62 9.422-12.018zM56.63 42.907c0-4.243.191-7.398 4.49-8.81l13.634-.541c6.556-.88 8.21 2.745 8.21 7.692v7.042c0 4.592-4.5 8.978-9.21 8.978h-9.609c-4.71 0-7.515-3.722-7.515-8.313z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E4EA"
      d="M115.763 51.712c0-6.455-5.378-11.609-11.826-11.335l-64.983 2.756a11.345 11.345 0 0 0-10.839 10.579l-3.071 45.98c-.437 6.549 4.756 12.102 11.32 12.102h68.054c6.265 0 11.345-5.08 11.345-11.345z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="M26.288 81.267 25.05 97.892" />
    <path
      fill="#6B7180"
      d="M66.563 79.096c-3.211-1.287-5.492-3.66-5.492-7.181 0-4.69 3.998-8.493 8.929-8.493 4.93 0 8.928 3.803 8.928 8.493 0 3.187-1.668 5.396-4.399 6.849l3.344 10.524c.223.632-.286 1.278-1.136 1.441L65.9 92.803c-1.106.212-2.14-.493-1.954-1.332z"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M105.627 39.875c2.613.041 8.297 1.863 10.136 8.822"
    />
  </svg>
);
export default LegacyEmptyLock;
